module.exports = __webpack_public_path__ + "28b67065/img/share-action-icon.9c12578c.svg";